import { useCheckFeatureFunction } from '../../../utils/hooks';
import { displayedPermissionList } from '../utils';

// XXX certain permissions (or permission items) are hidden behind feature flags.
const useFeatureFilteredPermissionList = () => {
  const checkFeatureFunc = useCheckFeatureFunction();
  return displayedPermissionList
    .filter(
      (permissionItem) =>
        !permissionItem.requiredFeature ||
        checkFeatureFunc(permissionItem.requiredFeature),
    )
    .map((permissionItem) => {
      return 'items' in permissionItem
        ? {
            ...permissionItem,
            items: permissionItem.items.filter(
              (item) =>
                !item.requiredFeature || checkFeatureFunc(item.requiredFeature),
            ),
          }
        : permissionItem;
    });
};

export default useFeatureFilteredPermissionList;
